import { Injectable } from '@angular/core';
import { BaseProductService } from './base-product.service';
import { IProductBase, IProductCreationParams, IProductDeleteParams, IProductReservationBase, IProductReservationParams, Profility } from 'model/product.interface';
import { ITicketProduct, PayloadUpdateTicket, ReservationITicketProduct } from 'model/ticket-product.interface';
import { keyRandomUnique } from 'utils/helpers';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketProductService extends BaseProductService {
  deleteProduct(params: IProductDeleteParams): IProductBase {
    throw new Error('Method not implemented.');
  }

  private readonly SUB_CATEGORY_ID = 9
  private readonly CATEGORY_NAME = 'TOURS';
  private readonly SUB_CATEGORY_NAME = 'TICKETS';


private form: any;

  createProduct(params: IProductCreationParams): IProductBase {

      const { item, product, payload, othersPerCategory } = params;

      if(!this.form) {
        this.form = JSON.parse(localStorage.getItem('form'));
      }

      const itemCopy = { ...item };
      const productCopy = { ...product };

      this.commonsValueProduct(itemCopy, productCopy, payload, this.form, othersPerCategory);
      this.setupTicketSpecificProperties(itemCopy, productCopy, payload, this.form, othersPerCategory);
       // Crear copia para payloadUpdate
      itemCopy.payloadUpdate = this._payloadUpdateTicket(
        payload,
        itemCopy,
        productCopy,
        othersPerCategory
      );

      itemCopy.destination = this.itineraryService.getDestinationInfo(this.form, itemCopy);

      return itemCopy as ITicketProduct;
    }

    validateProduct(item: any): boolean {
      throw new Error('Method not implemented.');
    }

    private commonsValueProduct(item: any, product: any, payload: any, form: any, othersData: any): void {

        item.id = product.optionId;
        item.searchId = othersData.searchId;
        item.providerId = item.providerId;
        item.from = othersData.from || '';
        item.providerName = item?.providerName;
        item.categoryName = this.CATEGORY_NAME;
        item.subCategoryId = this.SUB_CATEGORY_ID;
        item.subCategoryName = this.SUB_CATEGORY_NAME;
        item.currency = item.additionalInfo.currency;
        item.nameAdapter = item?.nameAdapter;
        item.updateDate = new Date();
    }

    private setupTicketSpecificProperties(item: any, product: any, payload: any, form: any, othersData: any): void {
          const cancellationPolicies = this.getCancellationPolicies(product, othersData.arrivalDate);
console.log(product)
console.log(item)
          item.tourId = item?.tourId;
          item.idProduct = product.optionId;
          item.location = item.location ?? null;
          item.company = item.additionalInfo.tours.company;
          item.form = form;
          item.arrivalDate = othersData.arrivalDate;
          item.hasReservationQuestions = item.additionalInfo?.tours?.hasReservationQuestions;
          item.questions = product.questions;
          item.images = item.additionalInfo?.images;
          item.selectDay = othersData.arrivalDate;
          item.selectHour = othersData.hourSelected;
          item.productKey = keyRandomUnique();
          item.payload = payload;
          item.bookParam = product.bookParam;
          item.origin = item.origin ?? null;
          item.ticket = product;
          item.cancellationPolicies = cancellationPolicies;
          item.expiration_date = cancellationPolicies.cancellationPolicies && cancellationPolicies.cancellationPolicies.length > 0
                             ? (cancellationPolicies.cancellationPolicies.dateFrom || this.adjustDate(cancellationPolicies.cancellationPolicies[0].dateFrom, -1))
                             : null;
          item.rateClassId = 'NR';
        item.paxesData = product.paxesData;

        item.netPriceUnitary = Number(item.paxesData.reduce((sum, price) => sum + (price.originalAmount * price.passengerCount), 0).toFixed(2));
        item.netPriceFreeTax = Number(item.paxesData.reduce((sum, price) => sum + (price?.pricing?.netPriceFreeTax || 0), 0).toFixed(2));
        item.netPrice = Number(item.paxesData.reduce((sum, price) => sum + (price.profility?.netPrice), 0).toFixed(2));
        item.totalPriceProf = Number(item.paxesData.reduce((sum, price) => sum + (price.total || 0), 0).toFixed(2));
        item.totalPrice = Number(item.paxesData.reduce((sum, price) => sum + (price.total || 0), 0).toFixed(2));
        item.blickoins = Number(item.paxesData.reduce((sum, price) => sum + (price.profility?.blickoins), 0).toFixed(2));
        item.creditBlickoins = Number(item.paxesData.reduce((sum, price) => sum + (price.profility?.creditBlickoins), 0).toFixed(2));

        item.netPriceFreeTax = item.experience?.netPriceBookingAddons ? item.netPriceFreeTax + item.experience?.netPriceBookingAddons : item.netPriceFreeTax;
        item.totalPriceProf = item.experience?.netPriceBookingAddons ? item.totalPriceProf + item.experience?.netPriceBookingAddons : item.totalPriceProf;
        item.netPrice = item.experience?.netPriceBookingAddons ? item.netPrice + item.experience?.netPriceBookingAddons : item.netPrice;
        item.totalPrice = item.experience?.netPriceBookingAddons ? item.totalPrice + item.experience?.netPriceBookingAddons : item.totalPrice;

        item.taxes = product.taxes ? product.taxes : [];
        item.taxPrice = product.taxPrice ? product.taxPrice : 0;
        item.tax = product.tax ? product.tax : 0;
        item.taxPriceNightTotal = 0;

        item.profilityOriginal = product.profility;
        item.pricingOriginal = product.pricing;

        item.paxProfility = item.paxesData.map(pax => pax.profility) || null;
        item.paxPricing = item.paxesData.map(pax => pax.pricing) || null;

        item.serviceExtra = this.getServiceExtra(item);

        item.profility = this.getProfility(item);

        item.pricing = this.getPricing(item);

        item.serviceExtra = this.getServiceExtra(item);

        item.title = item.title;
        item.productName = item.title;
        item.departureDate = othersData.arrivalDate;

        item.adults = item.paxesData.find(c => c.paxType === 'ADULT').passengerCount;
        let childrenCount = 0;

        item.paxesData.forEach((pax: any) => {
            if (pax.paxType !== 'ADULT' && pax.ageTo < 18) {
                childrenCount += pax.passengerCount || 0;
            }
        });

        item.childrens = childrenCount;
        item.additionalInfo.tours.options = [];

        }

              private adjustDate(date: string | Date, days: number): string {
        if (!date) return '';

        // Convertir Date a string si es necesario
        let dateStr: string;
        if (typeof date === 'string') {
          dateStr = date;
        } else {
          // Asumiendo que es un objeto Date
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          dateStr = `${year}-${month}-${day}`;
        }

        const d = new Date(dateStr);
        d.setDate(d.getDate() + days);
        return d.toISOString().split('T')[0];
      }


          private getProfility(item: any): Profility {
    return {
        blickoins: Number(item.paxProfility.reduce((sum, price) => sum + (price.blickoins || 0), 0).toFixed(2)),
        creditBlickoins: Number(item.paxProfility.reduce((sum, price) => sum + (price.creditBlickoins || 0), 0).toFixed(2)),
        netPrice: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPrice || 0), 0).toFixed(2)),
        netPriceBooking: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPriceBooking || 0), 0).toFixed(2)),
        netPriceCategory: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPriceCategory || 0), 0).toFixed(2)),
        netPriceProvider: Number(item.paxProfility.reduce((sum, price) => sum + (price.netPriceProvider || 0), 0).toFixed(2)),
        percentage: item.paxProfility[0].percentage || 0,
        percentageBooking: item.paxProfility[0].percentageBooking || 0,
        percentageCategory: item.paxProfility[0].percentageCategory || 0,
        percentageProvider: item.paxProfility[0].percentageProvider || 0
        };
  }

  private getPricing(item: any): any {
    return {
            blickoins: Number(item.paxPricing.reduce((sum, price) => sum + (price.blickoins || 0), 0).toFixed(2)),
            creditBlickoins: Number(item.paxPricing.reduce((sum, price) => sum + (price.creditBlickoins || 0), 0).toFixed(2)),
            netPriceFreeTax: Number(item.paxPricing.reduce((sum, price) => sum + (price.netPriceFreeTax || 0), 0).toFixed(2)),
            netPriceProf: Number(item.paxPricing.reduce((sum, price) => sum + (price.netPriceProf || 0), 0).toFixed(2)),
            totalPriceFreeTax: Number(item.paxPricing.reduce((sum, price) => sum + (price.totalPriceFreeTax || 0), 0).toFixed(2)),
            totalPriceProf: Number(item.paxPricing.reduce((sum, price) => sum + (price.totalPriceProf || 0), 0).toFixed(2)),
            percentage: item.paxPricing[0].percentage || 0,
            creditFactor: item.paxPricing[0].creditFactor,
            blickoinsFactor: item.paxPricing[0].blickoinsFactor,
    }
  }


      private getCancellationPolicies(productTicket: any, selectDay: any): any {

        return [];

      }

      private getServiceExtra(item: any): any[] {

      let arr: any[] = [];

      if(item.ticket.addonsIncluded && item.ticket.addonsIncluded.length > 0) {
        item.ticket.addonsIncluded.forEach((addons: any) => {
          arr.push({
            name: addons.description,
            price: addons.netPriceProf
          });
        });
      }

      return arr;
    }


    private _payloadUpdateTicket(payload: any, item: any, product: any, othersData: any): PayloadUpdateTicket {

          let others;
          let payloadUpdate: PayloadUpdateTicket;

           others = {
                  agedriver: environment.agedriver,
                  serialized: environment.serialized,
                  maxRequestTimeOnSeconds: environment.maxRequestTimeOnSeconds,
                  minNumResults: environment.minNumResults,
                  maxNumResultsPerAdapter: environment.maxNumResultsPerAdapter,
                  tours: othersData.payloadUpdate.others !== undefined ? othersData.payloadUpdate.others.tours : othersData.payloadUpdate.products[0].others,
          };

              payloadUpdate = {
                products: [
                  {
                    market: 2,
                    providerId: item.providerId,
                    nameAdapter: item.nameAdapter,
                    categoriesId: [9],
                    productId: item.productId,
                    productName: item.title,
                    destination: payload[0].destination,
                    priceFrom: null,
                    priceTo: null,
                    arrivalDate: othersData.arrivalDate,
                    departureDate: othersData.arrivalDate,
                    others: others,
                    agencyId: othersData.userService._agencyID,
                    bookingCode: product.bookParam,
                    id: product.optionId,
                    paxType: product.paxType ? product.paxType : this.getPaxtAdult(product)
                  },
                ],
              };

                let children: string[] = [];

               if (product?.assignedPassengers && Array.isArray(product.assignedPassengers)) {
                  product.assignedPassengers.forEach((passenger: any) => {
                    // Verificar que age existe y es un número válido
                    const age = passenger?.age;
                    if (age !== undefined && age !== null && age !== '' && Number(age) < 18) {
                      children.push(age.toString());
                    }
                  });
                }

                payloadUpdate["products"][0]["others"]["tours"]["adults"] = item.paxesData.find(c => c.paxType === 'ADULT').passengerCount;
                payloadUpdate["products"][0]["others"]["tours"]["children"] = children;

              return payloadUpdate;
    }

    getPaxtAdult(ticket: any): any {

      const adult = ticket.paxPrices.find(c => c.paxType === 'ADULT');

      const adultType = {
        type: adult.paxType,
        ageRange: {
          from: adult.ageFrom,
          to: adult.ageTo
        }
      }

      return adultType;
    }

    createReserve(params: IProductReservationParams): IProductReservationBase {

        const { item, paxes, itineraryId, othersPerCategory } = params;

        return item as ReservationITicketProduct;
    }


  }



